import { Browser } from "../utils/Browser";
import { LayaGL } from "../layagl/LayaGL";
import { VideoTexture } from "./VideoTexture";
import { PAL } from "../platform/PlatformAdapters";
import { HTMLVideoPlayer } from "./HTMLVideoPlayer";
export class HTMLVideoTexture extends VideoTexture {
    constructor() {
        super();
        this._needUpdate = true;
        this._hasRequestVideoFrame = false;
        let ele = this.element = HTMLVideoPlayer.createElement();
        ele.addEventListener("loadedmetadata", () => this.setLoaded(this.element.videoWidth, this.element.videoHeight, Browser.onLayaRuntime));
        ele.addEventListener("canplay", () => {
            if (!this._loaded && this.element.videoWidth > 0 && this.element.videoHeight > 0)
                this.setLoaded(this.element.videoWidth, this.element.videoHeight, Browser.onLayaRuntime);
            if (!this._playing)
                this.render(true);
        });
        ele.addEventListener("ended", () => {
            this.event("ended");
        });
        if ("requestVideoFrameCallback" in HTMLVideoElement.prototype) {
            const scope = this;
            function updateVideo() {
                scope._needUpdate = true;
                ele.requestVideoFrameCallback(updateVideo);
            }
            ele.requestVideoFrameCallback(updateVideo);
            this._hasRequestVideoFrame = true;
        }
    }
    get currentTime() {
        return this.element.currentTime;
    }
    set currentTime(value) {
        this.element.currentTime = value;
        if (!this._playing && this._loaded)
            this.render();
    }
    get volume() {
        return this.element.volume;
    }
    set volume(value) {
        this.element.volume = value;
    }
    get readyState() {
        return this.element.readyState;
    }
    get duration() {
        return this.element.duration;
    }
    get ended() {
        return this.element.ended;
    }
    get loop() {
        return this.element.loop;
    }
    set loop(value) {
        this.element.loop = value;
    }
    get playbackRate() {
        return this.element.playbackRate;
    }
    set playbackRate(value) {
        this.element.playbackRate = value;
    }
    get muted() {
        return this.element.muted;
    }
    set muted(value) {
        this.element.muted = value;
    }
    onLoad(url) {
        HTMLVideoPlayer.setSrc(this.element, url);
        this.element.load();
    }
    onPlay() {
        this.element.play().catch(e => {
            if (e.name === "NotAllowedError")
                PAL.media.resumeUntilGotFocus(this);
            else
                console.warn(e);
        });
    }
    onPause() {
        this.element.pause();
    }
    onRender() {
        if (!this._hasRequestVideoFrame || this._needUpdate) {
            LayaGL.textureContext.updateVideoTexture(this._texture, this.element, false, false);
            this._needUpdate = false;
            return true;
        }
        else
            return false;
    }
    onDestroy() {
        HTMLVideoPlayer.setSrc(this.element, null);
        this.element.remove();
    }
}
